<div [class]="relatedNews ? 'card forceScroll' : 'card'" [class.no-shadow]="!shadow" tabindex="0">
  <header>
    <div class="button_icon ion-no-padding">
      <ion-back-button
        *ngIf="back"
        defaultHref="panel/network/home"
        (click)="router.navigateByUrl('/panel/network/home')"
        [ngStyle]="{ color: color }"
        [text]="translate.instant('common.back')">
      </ion-back-button>
    </div>

    <div class="loh fill left">
      <img class="icon" *ngIf="icon" [src]="icon" [ngStyle]="{ filter: color?.filter }" />
      <div class="bold marg">
        <h1>{{ title }}</h1>
      </div>
    </div>

    <ion-item (click)="presentPopover($event)" *ngIf="categories" class="flex-direction-news margin">
      <ion-label [hidden]="selectedCategory.name[translate.currentLang]!.length > 0" class="label-popover" translate
        >common.categories</ion-label
      >

      <ion-label [hidden]="selectedCategory.name[translate.currentLang]!.length <= 0" class="label-popover">{{
        selectedCategory.name[translate.currentLang]
      }}</ion-label>
      <ion-icon class="icon-popover" name="chevron-down-outline"></ion-icon>
    </ion-item>
  </header>

  <ion-row [hidden]="!loading || !dashboard">
    <ion-col size="6" *ngFor="let fake of fakeElementsLarg">
      <app-post-medium-loading class="medium-post"></app-post-medium-loading>
    </ion-col>
  </ion-row>

  <main [hidden]="notFound || empty" [class]="highlight ? 'height-h' : ''" class="p0">
    <ng-content select="[data]"></ng-content>
  </main>

  <footer [hidden]="!moreButton || notFound || empty || !dashboard" class="notAbsolutFooter" *ngIf="viewMore">
    <ion-button extra class="more-button" fill="clear" [routerLink]="route" routerDirection="root">
      <ion-label color="primary" style="text-align: center" translate>common.more</ion-label>
    </ion-button>
  </footer>

  <app-not-found [hidden]="!notFound"></app-not-found>
  <app-empty-result [hidden]="!empty"></app-empty-result>
</div>
